import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { Box, BoxProps, Typography } from '@mui/material';
import CreateSpeedDial from 'components/CreateSpeedDial';
import PersonService from 'services/person';
import { LOGOS } from 'shared/constants';
import { MH_ROLES } from 'services/auth';
import { UserContext } from 'shared/contexts/UserContext';
import { ROUTES } from 'shared/routes';
import { FIRM_COMPANY } from 'services/firm';
import S3Avatar from './S3Avatar';
import HeaderMenu from './HeaderMenu';
import NotificationIcon from './NotificationIcon';
import HeaderTitle from './HeaderTitle';

const HeaderMobile: React.FC<BoxProps> = ({ sx }: BoxProps) => {
  const [userState] = useContext(UserContext);
  const { role, person } = userState;
  const { avatar } = person;
  const isInternal = MH_ROLES.includes(role);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box
      component="header"
      sx={[
        (t) => ({
          alignItems: 'center',
          backgroundColor: t.palette.common.white,
          borderBottom: `1px solid ${t.palette.divider}`,
          columnGap: '1rem',
          gridTemplateColumns: 'auto 1fr auto auto auto',
          gridColumn: 'header-start / header-end',
          gridRow: 'header-start / header-end',
          padding: '0.1rem 1rem',
          zIndex: 20,
        }),
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
      className={`${isInternal ? 'internal' : 'external'}`}
    >
      <Link
        to={ROUTES.home}
        style={{ display: 'block', lineHeight: 1 }}
      >
        <img
          src={LOGOS.voyager}
          alt={`${FIRM_COMPANY.name} logo`}
          height="32"
          width="32"
          style={{ height: '2rem', width: '2rem' }}
        />
      </Link>

      <Typography
        sx={(t) => ({
          flexGrow: 1,
          fontSize: '1rem',
          fontWeight: t.typography.fontWeightBold as any,
        })}
        component="h1"
      >
        <HeaderTitle />
      </Typography>

      <NotificationIcon />

      <CreateSpeedDial />

      <Box>
        <S3Avatar
          alt={PersonService.fullname(person)}
          sx={{ height: '2rem', width: '2rem', '&:hover': { cursor: 'pointer' } }}
          picture={avatar}
          onClick={handleClick}
          shadow
          id="header-avatar"
        />

        <HeaderMenu
          open={open}
          handleClose={handleClose}
          anchorEl={anchorEl}
        />
      </Box>
    </Box>
  );
};

export default HeaderMobile;
